export function prependZero(number) {
  if (number < 10) return `0${number.toString()}`;
  return number.toString();
}

export function titleCase(text) {
  let stringArray = text.split(' ');
  stringArray = stringArray.map((str) => str.charAt(0).toUpperCase() + str.toLowerCase().slice(1));
  return stringArray.join(' ');
}

export function twoDigits(text) {
  if (text.toString().length < 2) {
    return `0${text}`;
  }
  return text;
}

export function pluralize(word) {
  if (word[word.length - 1] === 's' || ['sh', 'ch'].includes(word.slice(-2)) || /[^aeuio]o$/.test(word)) {
    return `${word}es`;
  }

  if (/[^aeuio]y/.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }

  return `${word}s`;
}

export function camelToSnakeCase(text) {
  return text.replace(/([A-Z])/g, ($1) => `_${$1.toLowerCase()}`);
}

export function removeUnderscore(val) {
  return val.replace(/_/g, ' ');
}

export function stringToKebabCase(string) {
  return String(string).toLowerCase().replace(/ /g, '-');
}

export function titleToSlug(title) {
  return title
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
}

export default {
  camelToSnakeCase,
  prependZero,
  titleCase,
  twoDigits,
  removeUnderscore,
  titleToSlug,
};
